import React from "react";
import "./styles.css";

const ReporteCostos = () => {
  const powerBiUrl = "https://app.powerbi.com/view?r=eyJrIjoiMWYzMDJlOTctMWNkZS00NjIzLWJhZGQtM2ZiMThjYjI5YTRkIiwidCI6IjI5NDc5MDYzLWE0MGQtNDQzZC1iN2ZkLTRmNjExYzhjNWZlOCJ9";

  return (
    <div>
      <h1>Reporte de Costos</h1>
      <div>
        <div className="powerbi-iframe-container">
          <iframe
            title="Reporte de Costos - Power BI"
            src={powerBiUrl}
            className="powerbi-iframe"
            frameBorder="0"
            allowFullScreen={true}
            loading="lazy"
          />
        </div>
      </div>
    </div>
  );
};

export default ReporteCostos; 